export default __webpack_public_path__ + "static/media/failed-check.09531a5e.svg";